import { ImageRenditionFormat } from "@vertesia/common"

import { GetRenditionParams } from "@models/renditions"

const env = import.meta.env

export const RENDITION_OPTIONS: GetRenditionParams = {
    max_hw: env.VITE_RENDITION_HW || 256,
    format: ImageRenditionFormat.png,
    generate_if_missing: true,
}
